export default __webpack_public_path__ + "static/GRID22-how-to-read-data-conflict-es-cea5f1a312fed984407999220bb3be54.png";